<div [class]="theme ? theme : 'one-portal'">
  <button class="mat-dialog-close" mat-dialog-close>
    <mat-icon svgIcon="close"></mat-icon>
  </button>

  <div class="row" *ngIf="frame$ | async">
    <div class="col s12 l12">
      <div class="container">
        <!-- Frame -->
        <div class="row">
          <mat-card class="mat-card--widget">
            <mat-card-content>
              <div class="container">
                <div class="col s6">
                  <img
                    class="frame__image"
                    src="{{ frame?.largeImageUrl }}"
                    onError="this.src='/assets/images/frame-default-lg.png'"
                  />
                  <h2>{{ frame?.collectionName }} {{ frame?.styleName }}</h2>
                  <p>{{ frame?.colorDescription }}</p>
                  <p>{{ frame?.upc }}</p>
                  <p>{{ frame?.moduleName }}</p>
                </div>
                <div class="col s6" [formGroup]="FrameDetails">
                  <div>
                    <mat-form-field>
                      <mat-label class="filter-brand__label">
                        Select Return Reason *
                      </mat-label>
                      <mat-select
                        formControlName="returnReason"
                        (selectionChange)="setReturnReason()"
                        [compareWith]="compareValues"
                      >
                        <mat-option
                          [value]="reason"
                          *ngFor="let reason of returnReasons"
                          required
                          [disabled]="checkReturnable(reason)"
                          >{{ reason.text }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>

                    <mat-icon id="infoTooltip" [matTooltip]="getTooltipText()" matTooltipClass="my-tooltip"
                      >info</mat-icon
                    >

                    <mat-form-field>
                      <mat-label class="filter-brand__label">
                        Select Defect Reason
                      </mat-label>
                      <mat-select
                        formControlName="defectReason"
                        [compareWith]="compareValues"
                        [disabled]="disableDefectReason()"
                      >
                        <mat-option [value]="defect" *ngFor="let defect of defectReasons">{{ defect.text }}</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field>
                      <mat-label class="filter-brand__label">
                        Patient Name
                      </mat-label>
                      <input matInput name="patientName" [formControl]="patientName" />
                    </mat-form-field>
                    <div style="margin:0 0 0 -15px">
                      <div class="col s10 m10 l10">
                        <mat-form-field>
                          <input
                            matInput
                            formControlName="purchaseDate"
                            [matDatepicker]="picker"
                            placeholder="Original Purchase Date"
                          />
                        </mat-form-field>
                      </div>
                      <div class="col s2 m2 l2 align-search" style="margin:14px 0 0 -60px">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
  <div class="mat-dialog-footer" mat-dialog-actions>
    <div class="btn-group-vertical">
      <button
        cdkFocusInitial
        class="btn btn-primary"
        [mat-dialog-close]="true"
        (click)="SaveAndGoToCart()"
        [disabled]="isAddButtonDisabled()"
      >
        Save & View Cart
      </button>
      <button
        class="btn btn-outline"
        [mat-dialog-close]="true"
        (click)="SaveAndClose()"
        [disabled]="isAddButtonDisabled()"
      >
        Save & Add More
      </button>
    </div>
  </div>
</div>
